import { useEffect } from "react";

import {
  EmployeePageHeader,
  EmployeeSummary,
  EmployeeTable,
} from "./components";

import { useProbations } from "@hooks/HRM/employees/useProbations";
import { useRetirements } from "@hooks/HRM/retirements/useRetirements";
import { usePromotionsData } from "@hooks/HRM/promotions/usePromotions";
import { useUser } from "@hooks/useUser";

import { STATUS } from "@constants/status.hrm";
import { getAccess } from "@helpers/permissionController";

const { IN_PROGRESS } = STATUS;

const Employee = () => {
  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  const { pagination: retirementPagination } = useRetirements();
  const { pagination: permanentEmployeesPagination } = useProbations();
  const { pagination: promotionPagination, handleQuery } = usePromotionsData();

  useEffect(() => {
    handleQuery("status", IN_PROGRESS);
  }, []);

  return (
    <div className="d-flex flex-column gap-10 p-10">
      <EmployeePageHeader />
      {getAccess(roles, "CAN_VIEW_EMPLOYEE_STAT") && (
        <EmployeeSummary
          data={{
            retirement: retirementPagination?.total,
            permanentEmployee: permanentEmployeesPagination?.total,
            promotion: promotionPagination?.total,
          }}
        />
      )}
      <EmployeeTable />
    </div>
  );
};

export default Employee;
